var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRemove(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.623,
    height: 13.815,
    viewBox: "0 0 11.623 13.815",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-delete-4602521",
    transform: "translate(-118.164 -32.698)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_247810",
    "data-name": "Path 247810",
    d: "M129.787,35.949a1.344,1.344,0,0,0-1.344-1.344H126.3a2.3,2.3,0,0,0-4.54,0h-2.147a1.348,1.348,0,0,0-.192,2.689v7.829a1.394,1.394,0,0,0,1.391,1.391h6.438a1.394,1.394,0,0,0,1.391-1.391V37.294a1.344,1.344,0,0,0,1.152-1.344Zm-5.762-2.5a1.536,1.536,0,0,1,1.487,1.152h-2.973a1.536,1.536,0,0,1,1.487-1.152Zm3.841,11.67a.626.626,0,0,1-.622.622h-6.438a.626.626,0,0,1-.622-.622V37.294h7.683Zm.576-8.6h-8.835a.576.576,0,1,1,0-1.152h8.835a.576.576,0,1,1,0,1.152Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_247811",
    "data-name": "Path 247811",
    d: "M568.806,511.376a.384.384,0,0,0,.384-.384v-5.378a.384.384,0,1,0-.768,0v5.378a.384.384,0,0,0,.384.384Z",
    transform: "translate(-444.781 -466.784)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_247812",
    "data-name": "Path 247812",
    d: "M726.7,573.033a.384.384,0,0,0,.384-.384v-3.841a.384.384,0,1,0-.768,0v3.841a.384.384,0,0,0,.384.384Z",
    transform: "translate(-600.751 -529.209)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_247813",
    "data-name": "Path 247813",
    d: "M410.916,573.033a.384.384,0,0,0,.384-.384v-3.841a.384.384,0,0,0-.768,0v3.841a.384.384,0,0,0,.384.384Z",
    transform: "translate(-288.812 -529.209)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemove);
export default __webpack_public_path__ + "static/media/remove.b8c516a7bad1a951c53dfde22c1be52f.svg";
export { ForwardRef as ReactComponent };